// extracted by mini-css-extract-plugin
module.exports = {"icon":"searchTrigger_icon__GY1aV w-[28px] h-[28px] lg_w-[26px] lg_h-[26px] bg-no-repeat bg-contain"};